export default function youtubeVideoEmbed(videoId: string) {
  return `<iframe type="text/html" width="640" height="360"
  src="https://www.youtube.com/embed/${videoId}?autoplay=0&origin=${process.env.APP_PROTOCOL + '//' + process.env.APP_URL}"
  frameborder="0"></iframe>`
}